<div >
    <a class="btn btn-link btn-icon btn-icon--left btn-back hidden"
       [routerLink]="(clinicId) ? ['/clinics'] : ['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>

    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title help-btn">
                        <h2>
                            {{ 'Support Center' | translate }}
                        </h2>
                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-primary btn-block pl-3 pr-3" [routerLink]="['create/' + language]" [queryParams]="{ modalTitle: 'Add new Video', status: 'Created' }">
                        <i class="fas fa-search"></i>
                        {{ 'Add new Video' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="table--grid">
            <div class="table--grid__header">
                <div class="table--grid__header-tab active">
                    {{ 'Video' | translate }}
                    <input class="form-control" placeholder="{{ 'Search' | translate }}" [(ngModel)]="searchInfo.keyword" (input)="onSearchChange($event.target.value)">
                    <i *ngIf="searchInfo.keyword" class="fas fa-times" (click)="clearSearch()"></i>
                </div>
                <div class="table--grid__header-tab" [routerLink]="['/support/pdfs']">
                    {{ 'PDF' | translate }}
                </div>
                <div class="table--grid__header-tab" [routerLink]="['/support/basic']">
                    {{ 'Additional information' | translate }}
                </div>
                <div class="table--grid__header-tab" [routerLink]="['/support/release-note']">
                    {{ 'Release Notes' | translate }}
                </div>
            </div>
        </div>
        <div class="table--grid email-template-table">
            <div class="table--grid__body">
                <div class="row">
                    <div class="col-xs-11 col-lg-11">
                        <div class="row">
                            <div class="col-xs-8">
                                {{ 'Video name' | translate }}
                            </div>
                            <div class="col-xs-3">
                                {{ 'Views' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-1">
                        <ul class="list-inline languages">
                            <ng-container *ngFor="let lang of languages">
                                <li class="list-inline-item" [class.active]="language=== lang['code']" (click)="selectVideoBylanguage(lang['code'])">
                                    <a title="{{ 'Click here to show by ' + lang['name'] | translate }}">
                                        <img src="{{ '/assets/icon/flags/'  + lang['code'].toLowerCase() + '.png' }}" alt="{{lang['name']}}">
                                    </a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>

                <div cdkDropList *ngIf="movies.length ; else empty" class="example-list" (cdkDropListDropped)="drop($event)">
                    <div class="row example-box" cdkDrag *ngFor="let movie of movies">
                        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                        <div class="col-xs-11 col-lg-11">
                            <div class="row">
                                <div class="col-xs-8 col-lg-8">
                                    <span>
                                       {{ movie['title'] }}
                                    </span>
                                </div>
                                <div class="col-xs-3 col-lg-3">
                                    <span>
                                       {{ movie['views'] }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-4 col-lg-4 table--grid__actions table--grid__actions--hover">
                            <ul class="list-inline">
                                <li class="list-inline-item" [routerLink]="['edit/' + movie['id'] + '/' + language]" [queryParams]="{ modalTitle: 'Edit Video', status: 'Activated' }">
                                    <a class="btn btn-link table--grid__action-btn">
                                        <i class="fas fa-pencil-alt table--grid__actions__links__icon" aria-hidden="true"></i>
                                    </a>
                                </li>
                                <li class="list-inline-item" (click)="openConfirmModal({
                                    url: 'support/videos',
                                    id: movie['id'],
                                    action: 'delete',
                                    title: 'Delete Video',
                                    content: 'Are you sure you want to delete this Video?',
                                    icon: 'far fa-trash-alt',
                                    baseURL: 'support/videos',
                                    apiURL: 'support-center-video/'
                                })">
                                    <a class="btn btn-link table--grid__action-btn">
                                        <i class="far fa-trash-alt table--grid__actions__links__icon" aria-hidden="true"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <ng-template #empty>
                    <div class="text-xs-center pd-v--sm">
                        {{ 'No videos is matched your search criteria.' | translate }}
                    </div>
                </ng-template>

                <ng-template [ngIf]="!movies || movies.length === 0">
                    <div class="row text-xs-center hidden">
                        {{ 'No email template is matched your search criteria.' | translate }}
                        <a (click)="resetSearch()" class="text-primary back-btn">({{ 'Back to list' | translate }})</a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<dialog-component></dialog-component>
<router-outlet></router-outlet>


